import * as React from "react";

import { ShadcnChat } from "@features/chat/components/shadcn-chat/ShadcnChat";

const processEnv = (globalThis as { process?: { env?: Record<string, string | undefined> } }).process?.env;

export default function ChatPage() {
  const fallback = import.meta.env.VITE_CHAT_API_BASE;
  const apiBase = processEnv?.VITE_CHAT_API_BASE ?? fallback;

  if (!apiBase) {
    throw new Error("VITE_CHAT_API_BASE is required to render the chat page");
  }

  return <div className="container mx-auto max-w-6xl mt-10"><ShadcnChat apiBase={(processEnv?.VITE_CHAT_API_BASE ?? fallback)!} model="gpt-5-mini" /></div>;
}
